import { supabase } from './supabase';
import { extractFunctionErrorMessage } from '../utils/supabaseFunctionError';

const GENERIC_ERROR = 'No se pudo completar la operación. Intenta nuevamente.';

// Lectura: se apoya enteramente en las políticas RLS ya existentes
// (aplicacion_fertilizante_encabezado/detalle: "auth_user_id = auth.uid()"),
// igual que el módulo Aplicaciones — no hace falta Edge Function para listar
// ni ver detalle.

export async function listarAplicacionesFertilizantes() {
  const { data, error } = await supabase
    .from('aplicacion_fertilizante_encabezado')
    .select(
      'id, fechaaplicacion, horainicio, horafin, huerto, cuartel, superficie_ha, estado, created_at, aplicacion_fertilizante_detalle(id)'
    )
    .order('fechaaplicacion', { ascending: false })
    .order('created_at', { ascending: false });

  if (error) {
    return { ok: false, message: GENERIC_ERROR };
  }

  const aplicaciones = (data ?? []).map((row) => ({
    id: row.id,
    fechaaplicacion: row.fechaaplicacion,
    horainicio: row.horainicio,
    horafin: row.horafin,
    huerto: row.huerto,
    cuartel: row.cuartel,
    superficie_ha: row.superficie_ha,
    estado: row.estado,
    created_at: row.created_at,
    cantidadProductos: Array.isArray(row.aplicacion_fertilizante_detalle)
      ? row.aplicacion_fertilizante_detalle.length
      : 0,
  }));

  return { ok: true, aplicaciones };
}

export async function obtenerAplicacionFertilizante(id) {
  const { data, error } = await supabase
    .from('aplicacion_fertilizante_encabezado')
    .select(
      `id, fechaaplicacion, horainicio, horafin, huerto, cuartel, superficie_ha, estado, created_at,
       fecha_anulacion, motivo_anulacion,
       productores ( nombre ),
       aplicacion_fertilizante_detalle ( id, nombrecomercial, metodo, dosis_ha )`
    )
    .eq('id', Number(id))
    .maybeSingle();

  if (error) {
    return { ok: false, message: GENERIC_ERROR };
  }
  if (!data) {
    return { ok: false, message: 'La aplicación no existe.' };
  }

  return { ok: true, aplicacion: data };
}

// Escritura: siempre vía Edge Function -> RPC transaccional. Nunca INSERT
// directo desde el cliente (no hay policy de escritura para authenticated
// en estas tablas).
//
// payload puede incluir client_operation_id (uuid) para reintentos
// idempotentes: si ya se creó con ese id, el backend devuelve la misma
// aplicación en vez de duplicarla (ver crear_aplicacion_fertilizante_campo).
//
// networkError:true distingue "no hubo respuesta del servidor" de un error
// de validación/negocio con respuesta HTTP — la cola offline usa esta
// distinción para decidir si debe encolar localmente el intento.
export async function crearAplicacionFertilizante(payload) {
  const { data, error } = await supabase.functions.invoke('crear-aplicacion-fertilizante', { body: payload });
  if (error) {
    const message = await extractFunctionErrorMessage(error);
    const networkError = error?.name === 'FunctionsFetchError';
    return { ok: false, message: message || GENERIC_ERROR, networkError };
  }
  if (!data?.id) {
    return { ok: false, message: GENERIC_ERROR };
  }
  return { ok: true, id: data.id };
}
